'use strict';

export class RenderList {
  #active = config.threejs.renderList?.active || false;
  #list = config.threejs.renderList?.list || [];

  constructor (scene,renderer) {
    this.sortType = renderer.sortObjects ? 'renderOrder': 'order';
    this.scene = scene;
  }

  reorder() {
    if (!this.#list.length || !this.#active) return;

    this.#list.forEach(el => {
      const onScene = this.scene.getObjectByName(el.name);
      if (onScene) {
        if (this.sortType === 'order'){
          const parent = onScene.parent;
          const currentPosition = parent.children.indexOf(onScene);
          if (currentPosition !== -1 && currentPosition !== el.order){
            const target = parent.children[el.order];
            if (target) {
              parent.children[el.order] = onScene;
              parent.children[currentPosition] = target;
            }
          }
        } else {
          onScene.renderOrder = el.order;
        }
      }
    });
  }
}
